import React from 'react'

const Title = ({ children }: { children: React.ReactNode }) => (
  <div className="font-bold text-4xl text-[#252C32] py-3">{children}</div>
)

export default Title
